import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sass-two-funfacts',
  templateUrl: './sass-two-funfacts.component.html',
  styleUrls: ['./sass-two-funfacts.component.scss']
})
export class SassTwoFunfactsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
